import CoreInstance from '../CoreInstance';
import { getHeadersWithTokens, localeFlag } from 'api/ApiHelpers';

export interface IMaterials {
  getMaterial(id: number): any;
  getMaterials(page: number): any;
  searchMaterials(name: string): any;
  getCustomMaterial(id: number): any;
  getCustomMaterials(page: number): any;
  searchCustomMaterials(name: string): any;
  postCustomMaterials(materials: any[]): any;
  searchAllMaterials(name: string): any;
}

const centers: IMaterials = {
  getMaterial: (id) => CoreInstance.get(`/centers/materials/${id}`, getHeadersWithTokens(true)),
  getMaterials: (page) => CoreInstance.get(`/centers/materials?page=${page}`, getHeadersWithTokens(true)),
  searchMaterials: (name) => CoreInstance.get(`/centers/materials/search?name=${name}`, getHeadersWithTokens(true)),
  getCustomMaterial: (id) => CoreInstance.get(`/centers/custom_materials/${id}`, getHeadersWithTokens(true)),
  getCustomMaterials: (page) => CoreInstance.get(`/centers/custom_materials?page=${page}`, getHeadersWithTokens(true)),
  searchCustomMaterials: (name) => CoreInstance.get(`/centers/custom_materials/search?name=${name}`, getHeadersWithTokens(true)),
  postCustomMaterials: (materials) => CoreInstance.post('/centers/custom_materials', { custom_materials: materials }),
  searchAllMaterials: (name) => CoreInstance.get(`/centers/search_materials?name=${name}&${localeFlag()}`, getHeadersWithTokens(true)),
};

export default {
  centers,
};
